// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Петиції» (Petitions, ключ `petition`, група `constituents`). */
export const petitionsManifest: IModuleManifest = {
  key: 'petition',
  group: 'constituents',
  slug: 'petitions',
  prefix: 'PET',
  name: { en: 'Petitions', uk: 'Петиції' },
  entities: [
    { key: 'petition', slug: 'petition', name: { en: 'Petitions', uk: 'Петиції' }, main: true },
    { key: 'petition_signature', slug: 'petition-signature', name: { en: 'Petition Signatures', uk: 'Підписи' }, main: false },
    { key: 'petition_response', slug: 'petition-response', name: { en: 'Petition Responses', uk: 'Відповіді' }, main: false },
    { key: 'petition_milestone', slug: 'petition-milestone', name: { en: 'Petition Milestones', uk: 'Віхи' }, main: false },
    { key: 'petition_topic', slug: 'petition-topic', name: { en: 'Petition Topics', uk: 'Теми' }, main: false },
    { key: 'petition_status', slug: 'petition-status', name: { en: 'Petition Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/petitionsSlice').then((m) => m.petitionsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
